import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import querystring from "querystring";
import { log } from "../../utils/logger";

// State management
import { connect } from "react-redux";
import { resetPassword, signInUser } from "../../state/actions/userActions";

// Components
import Security from "../account/Password/Security";
import { toastr } from "react-redux-toastr";

const RequestPasswordReset = ({ history, resetPassword, signInUser }) => {
  // Get query string and parse into object
  const query_string = window.location.search.replace(/^\?/, "");
  const query_object = querystring.parse(query_string);

  // Establish state
  const [preFillPassword] = useState(query_object.p);
  const [user, setUser] = useState({
    current_password: preFillPassword || "",
    new_password: "",
    confirm_password: "",
  });

  useEffect(() => {
    history.push({ search: "" }); // Clear query string;
  }, [history]);

  function updatePassword({ target }) {
    log("Updating", target.name, "to", target.value);

    user[target.name] = target.value;
    setUser({ ...user });
  }

  function submitReset() {
    resetPassword(user).then((updatedUser) => {
      if (updatedUser) {
        toastr.success("Success", "You have successfully updated your password!");
        history.push("/");
      }
    });
  }

  return (
    <React.Fragment>
      <div className="text-center mt-4">
        <h1 className="h2">Reset password</h1>

        <p className="lead">Use the form below to update your password.</p>
      </div>

      <Security
        user={user}
        onChange={updatePassword}
        onSubmit={submitReset}
        disableCurrent={!!preFillPassword}
      />
    </React.Fragment>
  );
};

RequestPasswordReset.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  signInUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, { resetPassword, signInUser })(RequestPasswordReset);
